import * as React from 'react';
import * as moment from 'moment';

import Project from 'src/entities/Project';

import ProjectActionToolbarContainer from './partials/action-toolbar/ProjectActionToolbar.container';
import ProjectDetailsContainer from './partials/ProjectDetails.container';
import ProjectDocumentsComponent from './partials/project-documents/ProjectDocuments.component';
import ProjectListContainer from '../projects/ProjectList.container';
import ProjectMainInfoCardComponent from './partials/ProjectMainInfoCard.component';
import ProjectSummaryComponent from './partials/ProjectSummary.component';
import ProjectTeamMembersComponent from './partials/team-members/ProjectTeamMembers.component';
import ProjectCommentsContainer from './partials/comments/ProjectCommentList.container';
import ProjectBusinessModelComponent from './partials/ProjectBusinessModel.component';
import ProjectFinancialComponent from './partials/ProjectFinancial.component';
import ProjectMarketComponent from './partials/ProjectMarket.component';
import ProjectInterestedComponent from './partials/project-interested/ProjectInterested.component';
import ProjectMetricsComponent from './partials/ProjectMetrics.component';
import './partials/Project.css';
import ProjectInvestedComponent from './partials/project-invested/ProjectInvested.component';
import ProjectSidebarComponent from './partials/ProjectSidebar.component';
import ProjectFormalizationContainer from './partials/project-formalization/ProjectFormalization.container';
import ProjectMainInfoCardSuccessFundedComponent
  from 'src/modules/project/partials/ProjectMainInfoCardSuccessFunded.component';
import Investment from 'src/entities/Investment';
import NumberFormater from 'src/services/number-formater/NumberFormater.service';
import Person from 'src/entities/Person';
import ProjectDocument from 'src/entities/ProjectDocument';
import QuarterlyReportsComponent from 'src/modules/project/partials/quarterly-reports/QuarterlyReports.component';
import Payment from 'src/entities/Payment';
import ProjectPaymentComponent from 'src/modules/project/partials/project-payment/ProjectPayment.component';
import { isNullOrUndefined } from 'util';

export interface ShowProjectComponentProps {
  project: Project;
  isLogged: boolean;
  projectInterested: Person[];
  interestedUser: boolean;
  investedUser: boolean;
  activeProfile: Person;
  section: string;
  handleClick: (value: string) => void;
  handleInterested: () => void;
  projectInvested: Person[];
  investment?: Investment;
  companyDocument?: ProjectDocument;
  invest: boolean;
  payment?: Payment;
}

class ShowProjectComponent extends React.PureComponent<ShowProjectComponentProps> {

  closedProject: boolean = ((moment.utc(this.props.project.endDate, 'YYYY-MM-DD')
      .diff(moment(moment()), 'days') < 0) &&
    ((this.props.project.cash / this.props.project.cashTarget * 100) < 90));

  public render(): React.ReactNode {

    const investedCash = NumberFormater.euros(this.props.project.cash, 0);

    let invested;

    if (this.props.project.cashTarget === 0) {
      invested = 125;
    } else {
      invested = Math.round(this.props.project.cash / this.props.project.cashTarget * 100) <= 125 ?
        Math.round(this.props.project.cash / this.props.project.cashTarget * 100) : 125;
    }

    invested = invested / 100;

    const investedPercent = NumberFormater.percent(invested, 0);

    const progressBarWith = Math.floor(
      Math.min(invested, 1) * 100) + '%';

    const remainingTime = Math.max(
      moment.utc(this.props.project.endDate, 'YYYY-MM-DD').diff(moment(moment()).subtract(2, 'days'), 'days'),
      0
    );

    let activePayment = false;
    if (this.props.project.activePayment && this.props.payment) {
      activePayment = true;
    }

    let isPaid = false;
    if (this.props.investment && !isNullOrUndefined(this.props.investment.isPaid)) {
      isPaid = this.props.investment.isPaid;
    }
    
    return (
      <section>
        <div className="container">

          <div className="row">
            <div className="col-sm-12">
              {this.props.investment &&
              this.props.isLogged &&
              this.props.investedUser &&
              (this.props.project.status === 'Financiado con éxito' ||
                this.props.project.status === 'Formalizando operación') ?
                <ProjectMainInfoCardSuccessFundedComponent
                  project={this.props.project}
                  investment={this.props.investment}
                /> :
                <ProjectMainInfoCardComponent
                  project={this.props.project}
                  projectInterested={this.props.projectInterested}
                />
              }
            </div>
            <div className="col-sm-12" style={{display: 'flex'}}>
              <div style={{flexGrow: 2}}>
                {
                  this.props.project.status === 'En financiación' ?
                    <p className="f-s-22 text-center"><b>{investedCash}</b>
                      &nbsp;invertidos - {remainingTime} días restantes</p>
                    :
                    <p className="f-s-22 text-center"><b>{investedCash}</b> invertidos</p>
                }
                <div className="progress-bar-border">
                  <div className="progress-bar" style={{width: progressBarWith}}/>
                </div>
                <div className="gap-20"/>
              </div>
              <div className="col-xs-2 col-sm-1">
                <div className="gap-30"/>
                <span className="c-primary progress-bar-value">
                  {investedPercent}
                </span>
                <div className="gap-20"/>
              </div>
              <div>
                <ProjectActionToolbarContainer
                  project={this.props.project}
                  invest={this.props.invest}
                  closedProject={this.closedProject}
                />
                <div className="gap-30"/>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid box-shadow">
          <div className="container">
            <div className=" row">
              <ProjectSidebarComponent
                isLogged={this.props.isLogged}
                interestedUser={this.props.interestedUser}
                investedUser={this.props.investedUser}
                section={this.props.section}
                projectFounded={this.props.project.status === 'Financiado con éxito'}
                projectFormalization={this.props.project.status === 'Formalizando operación'}
                projectStatus={this.props.project.status!}
                closedProject={this.closedProject}
                activePayment={activePayment}
                isPaid={isPaid}
                handleClick={this.props.handleClick}
                handleInterested={this.props.handleInterested}
              />
              {this.renderProjectContent()}
            </div>
          </div>
        </div>
        <div className="gap-50"/>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h3 className="deco-title">
                Oportunidades de inversión
              </h3>
            </div>
          </div>
          <div className="gap-30"/>
          <ProjectListContainer
            status="open"
            limit={3}
            listKey="homeOpenProjects"
            isSimple={false}
          />
        </div>
      </section>
    );
  }

  private renderProjectContent(): React.ReactNode {
    switch (this.props.section) {
      case 'formalize':
        let activePayment = false;
        if (this.props.investment && !this.props.investment.isPaid && this.props.payment) {
          activePayment = true;
        }
        return (
          <ProjectFormalizationContainer
            project={this.props.project}
            investedUser={this.props.investedUser}
            activePayment={activePayment}
            handleChangeTab={this.props.handleClick}
          />
        );
      case 'payment':
        return (
          <ProjectPaymentComponent
            project={this.props.project}
            investment={this.props.investment!}
            payment={this.props.payment!}
          />
        );
      case 'resumen':
        return (
          <ProjectSummaryComponent
            project={this.props.project}
            isLogged={this.props.isLogged}
            invest={this.props.invest}
            closedProject={this.closedProject}
          />);
      case 'mercado':
        return (
          <ProjectMarketComponent
            project={this.props.project}
            invest={this.props.invest}
            closedProject={this.closedProject}
          />);
      case 'datos-financieros':
        return (
          <ProjectFinancialComponent
            project={this.props.project}
            invest={this.props.invest}
            closedProject={this.closedProject}
          />);
      case 'metricas':
        return (
          <ProjectMetricsComponent
            project={this.props.project}
            invest={this.props.invest}
            closedProject={this.closedProject}
          />);
      case 'detalles':
        return (
          <ProjectDetailsContainer
            project={this.props.project}
            invest={this.props.invest}
            closedProject={this.closedProject}
          />);
      case 'modelo-de-negocio':
        return (
          <ProjectBusinessModelComponent
            project={this.props.project}
            invest={this.props.invest}
            closedProject={this.closedProject}
          />);
      case 'equipo':
        return (
          <ProjectTeamMembersComponent
            project={this.props.project}
            teamMembers={this.props.project.teamMembers}
            invest={this.props.invest}
            closedProject={this.closedProject}
          />
        );
      case 'documentos':
        return (
          <ProjectDocumentsComponent
            project={this.props.project}
            investedUser={this.props.investedUser}
            activeProfile={this.props.activeProfile}
            companyDocument={this.props.companyDocument}
            invest={this.props.invest}
            closedProject={this.closedProject}
          />
        );
      case 'quarterly-reports':
        return (
          <QuarterlyReportsComponent
            project={this.props.project}
          />
        );
      case 'inversores':
        return (
          <ProjectInvestedComponent
            projectInvested={this.props.projectInvested}
            project={this.props.project}
            invest={this.props.invest}
            closedProject={this.closedProject}
          />);
      case 'interesados':
        return (
          <ProjectInterestedComponent
            projectInterested={this.props.projectInterested}
            project={this.props.project}
            invest={this.props.invest}
            closedProject={this.closedProject}
          />);
      case 'comentarios':
        return (
          <ProjectCommentsContainer
            project={this.props.project}
            invest={this.props.invest}
            closedProject={this.closedProject}
          />
        );
      default:
        return null;
    }
  }
}

export default ShowProjectComponent;



// WEBPACK FOOTER //
// ./src/modules/project/ShowProject.component.tsx